import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "./mobile.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { MantineProvider, localStorageColorSchemeManager } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";

import { theme } from "./theme";
import { queryClient } from "./queryClient";
import { router } from "./router";
import { LiveStreamProvider } from "./hooks/useLiveStream";
import { MarketProvider } from "./hooks/useMarket";
import { installMobileTableLabels } from "./lib/mobileTableLabels";

const WS_URL =
  (import.meta.env.VITE_WS_URL as string | undefined) ??
  (import.meta.env.DEV
    ? "ws://127.0.0.1:8090/ws/live"
    : (typeof window !== "undefined"
      ? `${window.location.protocol === "https:" ? "wss" : "ws"}://${window.location.host}/ws/live`
      : "ws://127.0.0.1:8090/ws/live"));

const root = document.getElementById("root");
if (!root) throw new Error("missing #root");

const colorSchemeManager = localStorageColorSchemeManager({ key: "poly-bot-v2-color-scheme" });
installMobileTableLabels();

createRoot(root).render(
  <StrictMode>
    <MantineProvider theme={theme} defaultColorScheme="dark" colorSchemeManager={colorSchemeManager}>
      <Notifications position="top-right" />
      <QueryClientProvider client={queryClient}>
        <MarketProvider>
          <LiveStreamProvider url={WS_URL}>
            <RouterProvider router={router} />
          </LiveStreamProvider>
        </MarketProvider>
      </QueryClientProvider>
    </MantineProvider>
  </StrictMode>,
);
